module.exports = __webpack_public_path__ + "static/media/store02.5199293d.jpg";